import { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import "@/admin.css";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const LOGO = "/wp-content/uploads/2022/08/logo.png";

function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export default function AdminLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    if (busy) return;
    setBusy(true);
    setError("");
    try {
      await axios.post(`${API}/auth/login`, { email, password }, { withCredentials: true });
      navigate("/admin", { replace: true });
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="admin-login-wrap" data-testid="admin-login-page">
      <form onSubmit={submit} className="admin-login-card" data-testid="admin-login-form">
        <img src={LOGO} alt="Children's Parliament" className="admin-login-logo" />
        <h1 className="admin-login-title">Admin Login</h1>
        {error && (
          <div className="admin-error" data-testid="admin-login-error">
            {error}
          </div>
        )}
        <label className="admin-label" htmlFor="admin-email">Email</label>
        <input
          id="admin-email"
          data-testid="admin-email-input"
          type="email"
          required
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          className="admin-input"
        />
        <label className="admin-label" htmlFor="admin-password">Password</label>
        <input
          id="admin-password"
          data-testid="admin-password-input"
          type="password"
          required
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          className="admin-input"
        />
        <button type="submit" disabled={busy} className="admin-btn" data-testid="admin-login-submit">
          {busy ? "Signing in..." : "Sign In"}
        </button>
        <a href="/" className="admin-link" data-testid="admin-login-back">
          Back to the website
        </a>
      </form>
    </div>
  );
}
